<template>
  <div>
    <el-page-header
      content="Change Server Type"
      @back="$emit('back')"
    />

    <el-row :gutter="15">
      <el-col :span="16">
        <p>
          <span v-if="hasFeature('RESIZE-DOWNSCALE', plan.features)">
          This will only increase or decrease the CPU and RAM. This can be reversed.<br>
          </span>
          Your server will be <strong>turned off</strong> during the resize.</p>
      </el-col>

      <el-col :span="8" class="align-right">
        <el-switch
          v-model="reserved"
          :active-value="true"
          :inactive-value="false"
          active-text="Monthly rate"
          inactive-text="Hourly rate"
          :disabled="hasFeature('FROZEN-MONTHLY-RATE', plan.features)"
        />
      </el-col>
    </el-row>

    <Plans
      :data="instancePlans"
      :storage-size="instance.storage.size"
      :plan-id.sync="planId"
      :show-provider="false"
      :sandbox="false"
    />
  </div>
</template>

<script>
import Plans from './Plans'

export default {
  props: {
    plan: Object,
    instance: Object
  },
  components: {
    Plans
  },
  data () {
    return {
      planId: this.instance.planId,
      reserved: this.instance.reserved
    }
  },
  computed: {
    newPlan () {
      return this.plans.find((p) => p.id === this.planId)
    },
    instancePlans () {
      return this.plans.filter((p) => p.provider.name === this.plan.provider.name &&
       p.provider.datacenter === this.plan.provider.datacenter && p.active &&
        (!p.storage || p.storage >= this.plan.storage))
    }
  },
  methods: {
    resize () {
      const cpu = this.newPlan.vcpus + ' ' + this.plural('CPU', this.newPlan.vcpus)
      const memory = this.newPlan.memory + ' GB Memory'
      const msg = 'Resize server for ' + cpu + ' and ' + memory + ' ?  To confirm, please enter RESIZE below.'
      const payload = { ...this.instance }
      payload.planId = this.planId
      payload.reserved = this.reserved

      this.$prompt(msg, 'Your server will be turned off', {
        confirmButtonText: 'Resize Server',
        cancelButtonText: 'Cancel',
        inputValidator: (value) => value === 'RESIZE',
        inputErrorMessage: 'Invalid input'
      }).then(() => {
        this.$store.dispatch('resizeInstance', payload).then((res) => {
          console.log(res)
        })
      }).catch(() => {})
    }
  },
  watch: {
    planId (value) {
      if (value && value !== this.instance.planId) {
        this.$nextTick(this.resize)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  p {
    margin-top: 0;
    line-height: 23px;
  }
</style>
